"use strict";

exports.__esModule = true;
var _PluginContext = require("./PluginContext");
Object.keys(_PluginContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginContext[key]) return;
  exports[key] = _PluginContext[key];
});
var _PluginButtonBar = require("./PluginButtonBar");
Object.keys(_PluginButtonBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginButtonBar[key]) return;
  exports[key] = _PluginButtonBar[key];
});
var _PluginButton = require("./PluginButton");
Object.keys(_PluginButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginButton[key]) return;
  exports[key] = _PluginButton[key];
});
var _PluginsList = require("./PluginsList");
Object.keys(_PluginsList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginsList[key]) return;
  exports[key] = _PluginsList[key];
});